// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Training / coach session room — follows global light/dark mode on html/body */
.training-theme-root {
  background: var(--bg-color) !important;
  color: var(--text-color);
  transition: background-color 0.3s ease, color 0.3s ease;
}

.training-theme-root h1,
.training-theme-root h2,
.training-theme-root h3,
.training-theme-root h4,
.training-theme-root h5,
.training-theme-root h6 {
  color: var(--text-color);
}

.training-theme-root p {
  color: var(--text-secondary);
}

/* Header */
.training-theme-root .header-info > h3 {
  color: var(--text-color) !important;
}

.training-theme-root .header-info > h3 span {
  color: var(--brand-primary) !important;
}

.training-theme-root .header-info > p {
  color: var(--text-secondary) !important;
}

.training-theme-root .clublogo {
  background: var(--surface-color) !important;
  border-color: var(--border-color) !important;
  box-shadow: 0 4px 10px var(--shadow-color) !important;
}

.training-theme-root .notification-btn {
  background: var(--surface-color) !important;
  border-color: var(--border-color) !important;
  color: var(--text-color) !important;
  box-shadow: 0 4px 10px var(--shadow-color) !important;
}

.training-theme-root .notification-btn:hover {
  background: var(--border-color) !important;
}

.training-theme-root .notification-btn svg {
  color: var(--text-color) !important;
}

/* Session info card */
.training-theme-root .session-info-card {
  background-color: var(--surface-color) !important;
  box-shadow: 0 4px 15px var(--shadow-color) !important;
  color: var(--text-color);
}

.training-theme-root .session-info-card__title {
  color: var(--text-color) !important;
}

.training-theme-root .session-info-card__meta,
.training-theme-root .session-info-card__meta-label {
  color: var(--text-secondary) !important;
}

.training-theme-root .session-info-card__edit-btn {
  background-color: var(--surface-color) !important;
  color: var(--brand-primary) !important;
  border-color: var(--brand-primary) !important;
}

.training-theme-root .session-info-card__schedule-line {
  color: var(--text-secondary) !important;
}

.training-theme-root .session-info-card__schedule-value {
  color: var(--text-color) !important;
}

/* Table setup */
.training-theme-root .table_setups {
  background: var(--surface-color) !important;
  color: var(--text-color);
  box-shadow: 0 2px 12px var(--shadow-color) !important;
  border: 1px solid var(--border-color);
}

.training-theme-root .table_player_label {
  background-color: var(--bg-color);
  color: var(--brand-primary);
  border-color: var(--brand-primary);
}

.training-theme-root .table_player_label:hover {
  background-color: rgba(var(--brand-primary-rgb), 0.12);
}

.training-theme-root .table_player_stats__points {
  color: var(--brand-primary-light, var(--brand-primary));
}

.training-theme-root .table_title,
.training-theme-root .table_addplayer_title {
  color: var(--brand-primary);
}

.training-theme-root .select_msg {
  color: var(--brand-primary);
}

.training-theme-root .session-setup ul li {
  background: var(--surface-color);
  border-color: var(--border-color);
  color: var(--text-color);
}

.training-theme-root .session-setup ul li .info h5,
.training-theme-root .session-setup ul li .info p {
  color: var(--text-color);
}

/* Exercise cards (training exercise list) */
.training-theme-root .ex_add_box {
  background: var(--surface-color) !important;
  border-color: var(--border-color) !important;
  box-shadow: 0 2px 12px var(--shadow-color) !important;
}

.training-theme-root .ex_add_box__title {
  color: var(--text-color) !important;
}

.training-theme-root .ex_add_box__subtitle,
.training-theme-root .ex_add_box__min,
.training-theme-root .ex_add_box__state-text {
  color: var(--text-secondary) !important;
}

.training-theme-root .ex_add_box__duration-input {
  background: var(--bg-color);
  color: var(--text-color);
  border-color: var(--border-color);
}

.training-theme-root .session_add_box {
  background: var(--surface-color);
  color: var(--text-color);
}

.training-theme-root .current-activity-info {
  background-color: rgba(var(--brand-primary-rgb), 0.1);
  border-color: rgba(var(--brand-primary-rgb), 0.35);
}

.training-theme-root .current-activity-info h3,
.training-theme-root .current-exercise-details p,
.training-theme-root .current-sequence-details p {
  color: var(--text-color);
}

.training-theme-root .current-exercise-details strong,
.training-theme-root .current-sequence-details strong {
  color: var(--brand-primary);
}

/* MUI surfaces inside training room */
.training-theme-root .MuiPaper-root {
  background: var(--surface-color) !important;
  color: var(--text-color) !important;
  border-color: var(--border-color) !important;
}

.training-theme-root .MuiTypography-root {
  color: inherit;
}

.training-theme-root .MuiFormControlLabel-label {
  color: var(--text-color) !important;
}

.training-live-access {
  display: flex;
  align-items: center;
  gap: 14px;
  width: 100%;
  max-width: 720px;
  margin: 0 auto 16px;
  padding: 14px 16px;
  border: none;
  border-radius: 14px;
  cursor: pointer;
  text-align: left;
  color: #fff;
  background: linear-gradient(
    135deg,
    var(--brand-primary-light, #0a8cd8),
    var(--brand-primary, #0877bc)
  );
  box-shadow: 0 8px 22px rgba(var(--brand-primary-rgb, 8, 119, 188), 0.28);
  transition: transform 0.25s cubic-bezier(0.25, 1, 0.5, 1),
    box-shadow 0.25s cubic-bezier(0.25, 1, 0.5, 1);
}

.training-live-access:hover {
  transform: scale(1.015);
  box-shadow: 0 10px 26px rgba(var(--brand-primary-rgb, 8, 119, 188), 0.36);
}

.training-live-access:active {
  transform: scale(0.985);
}

.training-theme-root--live-docked {
  padding-bottom: 148px !important;
}

.training-live-access--docked {
  position: fixed;
  left: 12px;
  right: 12px;
  bottom: calc(84px + env(safe-area-inset-bottom, 0px));
  z-index: 40;
  width: auto;
  max-width: none;
  margin: 0;
}

.training-live-access__dot {
  width: 10px;
  height: 10px;
  flex-shrink: 0;
  border-radius: 50%;
  background: #86efac;
  box-shadow: 0 0 0 0 rgba(134, 239, 172, 0.7);
  animation: training-live-pulse 1.8s ease-out infinite;
}

.training-live-access__icon {
  font-size: 28px !important;
  flex-shrink: 0;
}

.training-live-access__copy {
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
}

.training-live-access__copy strong {
  font-size: 16px;
  font-weight: 800;
  letter-spacing: 0.01em;
}

.training-live-access__copy span {
  font-size: 13px;
  font-weight: 500;
  opacity: 0.92;
}

@keyframes training-live-pulse {
  0% {
    box-shadow: 0 0 0 0 rgba(134, 239, 172, 0.55);
  }
  70% {
    box-shadow: 0 0 0 8px rgba(134, 239, 172, 0);
  }
  100% {
    box-shadow: 0 0 0 0 rgba(134, 239, 172, 0);
  }
}

.training-theme-root .session-info-card__live-btn {
  transition: transform 0.25s cubic-bezier(0.25, 1, 0.5, 1),
    box-shadow 0.25s cubic-bezier(0.25, 1, 0.5, 1);
}

.training-theme-root .session-info-card__live-btn:hover {
  transform: scale(1.03);
}

.training-theme-root .session-info-card__live-btn:active {
  transform: scale(0.97);
}

.training-theme-root .session-info-card__live-btn:focus-visible {
  outline: 3px solid var(--brand-primary, #0877bc);
  outline-offset: 2px;
}
`, "",{"version":3,"sources":["webpack://./src/pages/TrainingTheme.css"],"names":[],"mappings":"AAAA,gFAAgF;AAChF;EACE,sCAAsC;EACtC,wBAAwB;EACxB,uDAAuD;AACzD;;AAEA;;;;;;EAME,wBAAwB;AAC1B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA,WAAW;AACX;EACE,mCAAmC;AACrC;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,2CAA2C;EAC3C,4CAA4C;EAC5C,qDAAqD;AACvD;;AAEA;EACE,2CAA2C;EAC3C,4CAA4C;EAC5C,mCAAmC;EACnC,qDAAqD;AACvD;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,mCAAmC;AACrC;;AAEA,sBAAsB;AACtB;EACE,iDAAiD;EACjD,qDAAqD;EACrD,wBAAwB;AAC1B;;AAEA;EACE,mCAAmC;AACrC;;AAEA;;EAEE,uCAAuC;AACzC;;AAEA;EACE,iDAAiD;EACjD,sCAAsC;EACtC,6CAA6C;AAC/C;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,mCAAmC;AACrC;;AAEA,gBAAgB;AAChB;EACE,2CAA2C;EAC3C,wBAAwB;EACxB,qDAAqD;EACrD,qCAAqC;AACvC;;AAEA;EACE,iCAAiC;EACjC,2BAA2B;EAC3B,kCAAkC;AACpC;;AAEA;EACE,sDAAsD;AACxD;;AAEA;EACE,uDAAuD;AACzD;;AAEA;;EAEE,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,gCAAgC;EAChC,iCAAiC;EACjC,wBAAwB;AAC1B;;AAEA;;EAEE,wBAAwB;AAC1B;;AAEA,4CAA4C;AAC5C;EACE,2CAA2C;EAC3C,4CAA4C;EAC5C,qDAAqD;AACvD;;AAEA;EACE,mCAAmC;AACrC;;AAEA;;;EAGE,uCAAuC;AACzC;;AAEA;EACE,2BAA2B;EAC3B,wBAAwB;EACxB,iCAAiC;AACnC;;AAEA;EACE,gCAAgC;EAChC,wBAAwB;AAC1B;;AAEA;EACE,qDAAqD;EACrD,kDAAkD;AACpD;;AAEA;;;EAGE,wBAAwB;AAC1B;;AAEA;;EAEE,2BAA2B;AAC7B;;AAEA,sCAAsC;AACtC;EACE,2CAA2C;EAC3C,mCAAmC;EACnC,4CAA4C;AAC9C;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX;;;;GAIC;EACD,wEAAwE;EACxE;kDACgD;AAClD;;AAEA;EACE,uBAAuB;EACvB,yEAAyE;AAC3E;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,eAAe;EACf,UAAU;EACV,WAAW;EACX,qDAAqD;EACrD,WAAW;EACX,WAAW;EACX,eAAe;EACf,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,4CAA4C;EAC5C,qDAAqD;AACvD;;AAEA;EACE,0BAA0B;EAC1B,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE;IACE,6CAA6C;EAC/C;EACA;IACE,4CAA4C;EAC9C;EACA;IACE,0CAA0C;EAC5C;AACF;;AAEA;EACE;kDACgD;AAClD;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,gDAAgD;EAChD,mBAAmB;AACrB","sourcesContent":["/* Training / coach session room — follows global light/dark mode on html/body */\n.training-theme-root {\n  background: var(--bg-color) !important;\n  color: var(--text-color);\n  transition: background-color 0.3s ease, color 0.3s ease;\n}\n\n.training-theme-root h1,\n.training-theme-root h2,\n.training-theme-root h3,\n.training-theme-root h4,\n.training-theme-root h5,\n.training-theme-root h6 {\n  color: var(--text-color);\n}\n\n.training-theme-root p {\n  color: var(--text-secondary);\n}\n\n/* Header */\n.training-theme-root .header-info > h3 {\n  color: var(--text-color) !important;\n}\n\n.training-theme-root .header-info > h3 span {\n  color: var(--brand-primary) !important;\n}\n\n.training-theme-root .header-info > p {\n  color: var(--text-secondary) !important;\n}\n\n.training-theme-root .clublogo {\n  background: var(--surface-color) !important;\n  border-color: var(--border-color) !important;\n  box-shadow: 0 4px 10px var(--shadow-color) !important;\n}\n\n.training-theme-root .notification-btn {\n  background: var(--surface-color) !important;\n  border-color: var(--border-color) !important;\n  color: var(--text-color) !important;\n  box-shadow: 0 4px 10px var(--shadow-color) !important;\n}\n\n.training-theme-root .notification-btn:hover {\n  background: var(--border-color) !important;\n}\n\n.training-theme-root .notification-btn svg {\n  color: var(--text-color) !important;\n}\n\n/* Session info card */\n.training-theme-root .session-info-card {\n  background-color: var(--surface-color) !important;\n  box-shadow: 0 4px 15px var(--shadow-color) !important;\n  color: var(--text-color);\n}\n\n.training-theme-root .session-info-card__title {\n  color: var(--text-color) !important;\n}\n\n.training-theme-root .session-info-card__meta,\n.training-theme-root .session-info-card__meta-label {\n  color: var(--text-secondary) !important;\n}\n\n.training-theme-root .session-info-card__edit-btn {\n  background-color: var(--surface-color) !important;\n  color: var(--brand-primary) !important;\n  border-color: var(--brand-primary) !important;\n}\n\n.training-theme-root .session-info-card__schedule-line {\n  color: var(--text-secondary) !important;\n}\n\n.training-theme-root .session-info-card__schedule-value {\n  color: var(--text-color) !important;\n}\n\n/* Table setup */\n.training-theme-root .table_setups {\n  background: var(--surface-color) !important;\n  color: var(--text-color);\n  box-shadow: 0 2px 12px var(--shadow-color) !important;\n  border: 1px solid var(--border-color);\n}\n\n.training-theme-root .table_player_label {\n  background-color: var(--bg-color);\n  color: var(--brand-primary);\n  border-color: var(--brand-primary);\n}\n\n.training-theme-root .table_player_label:hover {\n  background-color: rgba(var(--brand-primary-rgb), 0.12);\n}\n\n.training-theme-root .table_player_stats__points {\n  color: var(--brand-primary-light, var(--brand-primary));\n}\n\n.training-theme-root .table_title,\n.training-theme-root .table_addplayer_title {\n  color: var(--brand-primary);\n}\n\n.training-theme-root .select_msg {\n  color: var(--brand-primary);\n}\n\n.training-theme-root .session-setup ul li {\n  background: var(--surface-color);\n  border-color: var(--border-color);\n  color: var(--text-color);\n}\n\n.training-theme-root .session-setup ul li .info h5,\n.training-theme-root .session-setup ul li .info p {\n  color: var(--text-color);\n}\n\n/* Exercise cards (training exercise list) */\n.training-theme-root .ex_add_box {\n  background: var(--surface-color) !important;\n  border-color: var(--border-color) !important;\n  box-shadow: 0 2px 12px var(--shadow-color) !important;\n}\n\n.training-theme-root .ex_add_box__title {\n  color: var(--text-color) !important;\n}\n\n.training-theme-root .ex_add_box__subtitle,\n.training-theme-root .ex_add_box__min,\n.training-theme-root .ex_add_box__state-text {\n  color: var(--text-secondary) !important;\n}\n\n.training-theme-root .ex_add_box__duration-input {\n  background: var(--bg-color);\n  color: var(--text-color);\n  border-color: var(--border-color);\n}\n\n.training-theme-root .session_add_box {\n  background: var(--surface-color);\n  color: var(--text-color);\n}\n\n.training-theme-root .current-activity-info {\n  background-color: rgba(var(--brand-primary-rgb), 0.1);\n  border-color: rgba(var(--brand-primary-rgb), 0.35);\n}\n\n.training-theme-root .current-activity-info h3,\n.training-theme-root .current-exercise-details p,\n.training-theme-root .current-sequence-details p {\n  color: var(--text-color);\n}\n\n.training-theme-root .current-exercise-details strong,\n.training-theme-root .current-sequence-details strong {\n  color: var(--brand-primary);\n}\n\n/* MUI surfaces inside training room */\n.training-theme-root .MuiPaper-root {\n  background: var(--surface-color) !important;\n  color: var(--text-color) !important;\n  border-color: var(--border-color) !important;\n}\n\n.training-theme-root .MuiTypography-root {\n  color: inherit;\n}\n\n.training-theme-root .MuiFormControlLabel-label {\n  color: var(--text-color) !important;\n}\n\n.training-live-access {\n  display: flex;\n  align-items: center;\n  gap: 14px;\n  width: 100%;\n  max-width: 720px;\n  margin: 0 auto 16px;\n  padding: 14px 16px;\n  border: none;\n  border-radius: 14px;\n  cursor: pointer;\n  text-align: left;\n  color: #fff;\n  background: linear-gradient(\n    135deg,\n    var(--brand-primary-light, #0a8cd8),\n    var(--brand-primary, #0877bc)\n  );\n  box-shadow: 0 8px 22px rgba(var(--brand-primary-rgb, 8, 119, 188), 0.28);\n  transition: transform 0.25s cubic-bezier(0.25, 1, 0.5, 1),\n    box-shadow 0.25s cubic-bezier(0.25, 1, 0.5, 1);\n}\n\n.training-live-access:hover {\n  transform: scale(1.015);\n  box-shadow: 0 10px 26px rgba(var(--brand-primary-rgb, 8, 119, 188), 0.36);\n}\n\n.training-live-access:active {\n  transform: scale(0.985);\n}\n\n.training-theme-root--live-docked {\n  padding-bottom: 148px !important;\n}\n\n.training-live-access--docked {\n  position: fixed;\n  left: 12px;\n  right: 12px;\n  bottom: calc(84px + env(safe-area-inset-bottom, 0px));\n  z-index: 40;\n  width: auto;\n  max-width: none;\n  margin: 0;\n}\n\n.training-live-access__dot {\n  width: 10px;\n  height: 10px;\n  flex-shrink: 0;\n  border-radius: 50%;\n  background: #86efac;\n  box-shadow: 0 0 0 0 rgba(134, 239, 172, 0.7);\n  animation: training-live-pulse 1.8s ease-out infinite;\n}\n\n.training-live-access__icon {\n  font-size: 28px !important;\n  flex-shrink: 0;\n}\n\n.training-live-access__copy {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  min-width: 0;\n}\n\n.training-live-access__copy strong {\n  font-size: 16px;\n  font-weight: 800;\n  letter-spacing: 0.01em;\n}\n\n.training-live-access__copy span {\n  font-size: 13px;\n  font-weight: 500;\n  opacity: 0.92;\n}\n\n@keyframes training-live-pulse {\n  0% {\n    box-shadow: 0 0 0 0 rgba(134, 239, 172, 0.55);\n  }\n  70% {\n    box-shadow: 0 0 0 8px rgba(134, 239, 172, 0);\n  }\n  100% {\n    box-shadow: 0 0 0 0 rgba(134, 239, 172, 0);\n  }\n}\n\n.training-theme-root .session-info-card__live-btn {\n  transition: transform 0.25s cubic-bezier(0.25, 1, 0.5, 1),\n    box-shadow 0.25s cubic-bezier(0.25, 1, 0.5, 1);\n}\n\n.training-theme-root .session-info-card__live-btn:hover {\n  transform: scale(1.03);\n}\n\n.training-theme-root .session-info-card__live-btn:active {\n  transform: scale(0.97);\n}\n\n.training-theme-root .session-info-card__live-btn:focus-visible {\n  outline: 3px solid var(--brand-primary, #0877bc);\n  outline-offset: 2px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
